import services from './../../../shared/services/auth-service'

// TODO: refactorizar a funciones `static nameFunctions(){}` para no tener que instanciar la clase
export default class UserSession {
  /**
   * @returns {Object} NULL || TOKEN_INFO from localStorage
   */
  static getTokenStorage() {
    return localStorage.getItem('TOKEN_INFO') !== null
      ? { ...JSON.parse(localStorage.getItem('TOKEN_INFO')) }
      : null
  }

  static getUserInfoStorage() {
    return localStorage.getItem('USER_INFO') !== null
      ? { ...JSON.parse(localStorage.getItem('USER_INFO')) }
      : null
  }

  static setDataActivityStorage(payload) {
    localStorage.setItem(
      'USER_INFO',
      JSON.stringify({ ...this.getUserInfoStorage(), dataActivity: payload })
    )
  }

  static async userAuth(payload) {
    return services.authentication(payload).then(res => {
      if (res.status === 200)
        localStorage.setItem(
          'TOKEN_INFO',
          JSON.stringify({
            accessToken: res.data.token.accessToken,
            expiresIn: res.data.token.expiresIn,
            idToken: res.data.token.idToken,
            tokenType: res.data.token.tokenType,
            refreshToken: res.data.token.refreshToken,
            email: res.data.email,
          })
        )
      return res
    })
  }

  static async userInfo() {
    let token = this.getTokenStorage()
    if (token) {
      var tokenId = token.idToken
      var config = {
        headers: {
          Authorization: tokenId,
        },
      }
      return services.sessionInfo(config).then(res => {
        switch (res.status) {
          case 200:
            localStorage.setItem('USER_INFO', JSON.stringify(res.data))
            break
          default:
            throw res
        }
        return res
      })
    } else {
      return Promise.reject({
        status: 0,
        userMessage: 'No existe una session activa',
        developerMessage: 'Not token available',
      })
    }
  }

  static async updateInfo(payload) {
    let token = this.getTokenStorage()
    if (token) {
      const tokenId = token.idToken
      const config = {
        headers: {
          Authorization: tokenId,
        },
      }
      return services.updateAccount(payload, config).then(res => {
        if (res.status === 200) {
          localStorage.setItem('USER_INFO', JSON.stringify(res.data))
        }
        return res
      })
    } else {
      return Promise.reject({
        status: 0,
        userMessage: 'No existe una session activa',
        developerMessage: 'Not token available',
      })
    }
  }

  static destroySession() {
    localStorage.removeItem('USER_INFO')
    localStorage.removeItem('TOKEN_INFO')
  }
}
